import React from 'react';
import SocialContainer from './SocialContainer';

const SocialView = () => {
  return <SocialContainer />;
};

export default SocialView;
